import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { listUsers, addUser, updateUserAdmin, removeUser } from '../api/client';

export function useUsers() {
  return useQuery({
    queryKey: ['admin', 'users'],
    queryFn: listUsers,
    staleTime: 30 * 1000,
  });
}

export function useAddUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ email, isAdmin }: { email: string; isAdmin?: boolean }) =>
      addUser(email, isAdmin),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
    },
  });
}

export function useUpdateUserAdmin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ email, isAdmin }: { email: string; isAdmin: boolean }) =>
      updateUserAdmin(email, isAdmin),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
    },
  });
}

export function useRemoveUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (email: string) => removeUser(email),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
    },
  });
}
